import { render, staticRenderFns } from "./CreateGroups.vue?vue&type=template&id=5a05acbd"
import script from "./CreateGroups.vue?vue&type=script&lang=js"
export * from "./CreateGroups.vue?vue&type=script&lang=js"
import style0 from "./CreateGroups.vue?vue&type=style&index=0&id=5a05acbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports